import type { AnalyticsEventParams } from '@/shared/analytics/events'

export const getAnalyticsDefaultParams = (
  params?: AnalyticsEventParams,
): AnalyticsEventParams => {
  return {
    page_path: window.location.pathname,
    page_location: window.location.href,
    page_title: document.title,
    ...params,
  }
}
